import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Paper, Typography, CircularProgress, TextField, MenuItem, Checkbox, Pagination, InputAdornment, Chip, IconButton, Tooltip } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import './payroll.css'
import Modal from 'react-bootstrap/Modal';
import PageLoader from '../../components/PageLoader/PageLoader';
import CalendarLoader from '../../components/Calendar/CalendarLoader';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import MyTable from '../../components/Schedule/MyTable';
import EmptyState from '../../components/Error/EmptyState';
import ListView from './ListView';
import GridView from './GridView';
import EmptyData from './EmptyData';

const Payroll = () => {
  const [payrollData, setPayrollData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState('');
  const [date, setDate] = useState(null);
  const [viewType, setViewType] = useState("list");

  const dateRangeLabel = date
    ? `${moment(date).format('MMM D, YYYY')} – present`
    : `${moment().startOf('month').format('MMM D')} – ${moment().format('MMM D, YYYY')}`;

  const getPayrollRecordData = async () => {
    setLoading(true);
    try {
      const payload = date ? { date } : {};
      const response = await ApiService.post("/payroll/show/payrollRecord", payload);
      const processedData = response.map((row, index) => ({
        id: row.id || index,
        ...row,
      }));
      setPayrollData(processedData || [])
    } catch (error) {
      console.error(error?.data)
    }
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getPayrollRecordData()
  }, [date])


  return (
    <>
      {loading ? (
        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </Paper>
      ) :
        payrollData.length == 0 ?
          (
            <EmptyData />
          ) :
          (
            <Paper className="p-4" style={{ marginTop: "1rem" }}>
              <div>
                <Grid container spacing={0} alignItems="center" justifyContent="space-between">
                  <Grid item xs={3}>
                    <Typography variant="h5">Payroll Record</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      Showing: <strong>{dateRangeLabel}</strong>
                    </Typography>
                  </Grid>

                  <div className='d-flex gap-3 align-items-center' >
                    <Grid item xs={'auto'}>
                      <Link to="/firehouse/manage-payroll">
                        <ButtonTheme type='submit' variant="filled" color='blue' style={{ height: 38 }}>
                          Manage Payroll Config
                        </ButtonTheme>
                      </Link>
                    </Grid>

                    <Grid item xs={'auto'}>
                      <Link to="/firehouse/add-payroll">
                        <ButtonTheme type='submit' variant="filled" color='primary' style={{ height: 38 }}>
                          Add New
                        </ButtonTheme>
                      </Link>
                    </Grid>

                    <Grid item xs={6} sm={6} md={'auto'}>
                      <div
                        style={{
                          height: "48px",
                          border: "1px solid #EAECF0",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "48px",
                            height: "48px",
                            borderRight: "1px solid #EAECF0",
                            cursor: "pointer",
                          }}
                          onClick={() => setViewType("list")}
                        >
                          <img
                            src={viewType === "list" ? "/images/list-view.svg" : "/images/list-view-inactive.svg"}
                            height="20px"
                            width="20px"
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "48px",
                            height: "48px",
                            cursor: "pointer",
                          }}
                          onClick={() => setViewType("card")}
                        >
                          <img
                            src={viewType === "list" ? "/images/card-view-inactive.svg" : "/images/card-view.svg"}
                            height="22px"
                            width="22px"
                          />
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={'auto'} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <ButtonDatePicker
                          className='w-100'
                          label={date ? moment(date).format('MM-DD-YYYY') : 'This month'}
                          value={date ? moment(date).toDate() : null}
                          onChange={(e) => {
                            setDate(moment(e).format('YYYY-MM-DD'))
                          }}
                          style={{ height: 48 }}
                        />
                      </LocalizationProvider>
                      {date && (
                        <Tooltip title="Clear date filter (show this month)">
                          <IconButton
                            size="small"
                            onClick={() => setDate(null)}
                            sx={{ border: '1px solid #EAECF0', borderRadius: '8px', height: 36, width: 36 }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Grid>

                    <Grid item xs={'auto'}>
                      <TextField
                        id="outlined-basic"
                        label=""
                        placeholder='Search'
                        variant="outlined"
                        value={searchResult}
                        onChange={(e) => setSearchResult(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          maxHeight: 48,
                          height: 48,
                          "& .MuiOutlinedInput-root": {
                            height: "48px",
                          },
                          "& .MuiOutlinedInput-input": {
                            height: "auto",
                          },
                        }} />
                    </Grid>
                  </div>
                </Grid>
              </div>
              <div className='mt-4'>
                {
                  viewType == 'list' ?
                    <ListView data={payrollData} refresh={getPayrollRecordData} /> :
                    <GridView data={payrollData} refresh={getPayrollRecordData} />

                }

              </div>

            </Paper>
          )
      }
    </>
  )
}

export default Payroll;
